import { useAppContext } from 'hooks/useAppContext';
import sendToTracking from 'services/tracking';

export function useTracking() {
  const {
    state: {
      deviceSize: { isDesktop },
    },
  } = useAppContext();

  const device = isDesktop ? 'desktop' : 'mobile';

  const sendTracking = <T>(data: T) => sendToTracking({ device, ...data });

  return { sendTracking };
}
